export var Error;
(function (Error) {
    Error["ACCOUNT_DISABLED"] = "ACCOUNT_DISABLED";
    Error["API_KEY_REVOKED"] = "API_KEY_REVOKED";
    Error["API_KEY_INVALID"] = "API_KEY_INVALID";
    Error["API_KEY_REQUIRED"] = "API_KEY_REQUIRED";
})(Error || (Error = {}));
